export const AdminRoutes = {
  HOME: 'admin',
  SELLER: {
    REGISTER: 'bo-seller.register',
    LOGIN: 'bo-seller.login',
  },
}
